import React from "react";
import { Link, NavLink } from "react-router-dom";
import SideMenuContext from "./../../common/context/sideMenuContext";
import { useAuth } from "../contexts/AuthContext";
import { loadImage } from "./../../common/services/uiService";
import SideBarAnamgis from "./fields/sidebar";
import "./../../common/styles/navbar.css";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";

const NavBar = () => {
  const { user, isAuthenticated, getUserDisplayName, logout } = useAuth();

  const userProfilePic = loadImage("UserProfilePic.svg");
  const logo1 = loadImage("logo_Anambra.png");
  const logo2 = loadImage("logo_Anambra.png");
  const logo3 = loadImage("logo_Anambra.png");

  const handleLogout = () => {
    logout();
    window.location.href = window.location.origin + "/home";
  };

  return (
    <React.Fragment>
      <div
        id="MainNavDiv"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* Desktop title */}
        <div
          id="Ministry-of-Lands-and-Natural-Resources-Online-Services"
          className="MinistryFullTitle"
        >
          <span>Ministry of Lands, Anambra State</span>
          <span className="separatorDiv"> | </span>
          <span>Admin Utility</span>
        </div>

        {/* Mobile and tablet title */}
        <div id="MLNR_TITLE" className="MinistryShortTitle">
          <span>Anambra State Government</span>
        </div>

        {isAuthenticated && user && (
          <div id="RightMenuUser">
            <div
              id="RightMenuUserControls"
              style={{ display: "flex", alignItems: "center", gap: "10px" }}
            >
              <div id="HelloUserDiv">
                <span className="HelloUser">{getUserDisplayName()}</span>
              </div>
              {/* <div className="userProfileDiv">
                <button
                  className="userProfilePicLink tooltip"
                  onClick={handleLogout}
                >
                  <img
                    src={userProfilePic}
                    className="userProfilePic"
                    alt="User Profile"
                  />
                  <div className="tooltiptext">Log out</div>
                </button>
              </div> */}
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default NavBar;
